<template>
  <div>
    <router-view></router-view>

    <CToaster :autohide="3000" position="bottom-right">
      <template v-for="(toast, index) in toasts">
        <CToast
          :key="'toast' + index"
          :show="true"
          :color="toast.color"
          :header="toast.title"
        >
          {{toast.content}}
        </CToast>
      </template>
    </CToaster>
  </div>
</template>

<script>
import Echo from "laravel-echo";
import Pusher from "pusher-js";
export default {
  created() {},
  name: "App",
  data() {
    return {
      show: false,
    };
  },
  watch: {
    currentUser: {
      handler(currentUser) {
        if (currentUser !== null) this.connect();
      },
    },
    isConnected: {
      handler(isConnected) {
        this.$emit("broadcasting:status", isConnected);
      },
    },
  },
  computed: {
    currentUser: {
      cache: false,
      get() {
        return this.$store.getters.currentUser;
      },
    },
    toasts: {
      cache: false,
      get() {
        return this.$store.getters.toasts;
      },
    },
    socketMessage: {
      cache: false,
      get() {
        return this.$store.getters.socketMessage.reverse();
      },
    },
    token: {
      cache: false,
      get() {
        return this.$store.getters.token;
      },
    },
    isConnected: {
      cache: false,
      get() {
        return (
          this.echo && this.echo.connector.pusher.connection.connection !== null
        );
      },
    },
  },
  methods: {
    /** Bind Channels **/
    bindChannels() {
      console.log("socket connected and binde channels");
      // let vm = this;
      this.echo.channel(`user.` + this.currentUser).listen("events", (data) => {
        console.log("amir");
        console.log(data);
      });
    },
    /** Disconnect Echo **/
    disconnect() {
      if (!this.echo) return;
      this.echo.disconnect();
    },
    connect() {
      if (!this.echo) {
        this.echo = new Echo({
          broadcaster: "pusher",
          key: "app-key",
          authEndpoint: "https://api.hamkaran.cloud/api/v1/broadcasting/auth",
          host: "ws.s1.hamkaran.cloud",
          wsHost: "ws.s1.hamkaran.cloud",
          wsPort: 80,
          wssPort: 443,
          forceTLS: true,
          auth: {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          },
          encrypted: true,
          disableStats: true,
          enabledTransports: ["ws", "wss"],
        });
        this.echo.connector.pusher.connection.bind("connected", (event) =>
          console.log(
            "%c Hamkaran Socket Conected",
            this.$store.getters.consoleLog.bold
          )
        );

        this.echo.connector.pusher.connection.bind("disconnected", () =>
          console.log("disconnected")
        );
      }
      console.log("inja");
      this.echo.connector.pusher.connect();
      this.bindChannels();
      this.echo.connector.pusher.connection.bind("message", (payload) => {
        console.log(
          "%c Get Event :"+ payload.event,
          this.$store.getters.consoleLog.message
        );
        // IF Get NewMessage From Socket
        if (payload.event == "NewMessage") {
          // If Get Type Contact Importer
          switch (payload.data.type) {
            case 'contactImporter':
                if ((payload.data.action = "showMessage")) {
                    this.$store.commit('contactImporterContent', payload.data.content)
                }
                if ((payload.data.action = "done")) {
                    this.$store.commit('contactImporterContentIsDone', payload.data.content)
                }
              break;

            case 'callExport':
                this.$store.commit('callExportStatus', payload.data.status)
              break;
          
          
            default:
              break;
          }



        }
      });
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
